import Service from '@ember/service';

import { service } from '@ember/service';
import { trackedFunction } from 'reactiveweb/function';

import config from 'rise-ui/config/config.js';
import { latest, or, readOnly } from 'rise-ui/utils/object/computed.js';
import { encodeObject, stripEmpties } from 'rise-ui/utils/query-params.js';

const { itemsPerPage } = config.catalog;

export default class CatalogSearchResultsService extends Service {
  @service ssr;
  @service notifications;
  @service scrollRoot;
  @service store;
  @service('catalog/search') search;

  include = 'catalogItems,location';

  @readOnly('search.params') params;

  _results = trackedFunction(this, async () => {
    if (this.ssr.isSsr) {
      return this.ssr.FOREVER;
    }
    if (this.store.isDestroyed) {
      return Promise.reject();
    }

    const { include, params } = this;
    const page = params.page || 1;
    const { search } = params;
    const orderOption = params.order || this.defaultOrder;
    const filter = encodeObject(params.filter || {}, { array: ',' });

    const order = {};
    this.orderLogic(orderOption, option => {
      const orderItem = this.orderLogicMap[option];
      if (orderItem) {
        order[`order[${orderItem.field}]`] ??= orderItem.dir;
      }
    });
    const results = await this.store.query('catalog-record', stripEmpties(Object.assign(
      {
        page,
        search,
        include,
        hasItemStructure: true,
        itemsPerPage,
      },
      filter,
      order,
    )));
    this.scrollRoot.scrollTo();
    return results;
  });
  @latest('_results') results;
  @or('results.value.meta', or.value({})) meta;

  defaultOrder = 'relevance';

  orderLogicMap = {
    fulltext:  { field: 'fulltext',     dir: 'DESC' },
    likematch: { field: 'likematch',    dir: 'DESC' },
    newest:    { field: 'updateDate',   dir: 'DESC' },
    oldest:    { field: 'updateDate',   dir: 'ASC'  },
    title:     { field: 'recordTitle',  dir: 'ASC'  },
  };

  orderLogic(option, orderBy) {
    if (option !== 'relevance') {
      orderBy(option);
    }
    if (option !== 'title') {
      orderBy('likematch');
      orderBy('fulltext');
      orderBy('title');
    }
  }
}
